
import { defineComponent, ref, computed, watchEffect } from 'vue';
import { getSeasonAverages } from '@/api/api'
import { UseRequest } from '@/utils/useRequest'
import { getSeasonAveragesParamType } from '@/types/api'

import ProgressBar from "@/components/ProgressBar.vue";
import Error from "@/components/Error.vue";
// import statsCard from "@/parts/statsCard.vue";

export default defineComponent({
  components: {
    ProgressBar,
    Error,
    // statsCard
  },
  props: {
    playerId: String,
    season: Number
  },
  setup(props) {

    const selectedFirstSeason = ref<number>(props.season!)
    const selectedSecondSeason = ref<number>(props.season! - 1)

    const seasonList = computed<number[]>(() => {
      return [...Array(props.season! + 1).keys()].filter(v => v >= 2000).sort((a, b) => b - a)
    })

    const firstSeasonAverages = new UseRequest(getSeasonAverages)
    watchEffect(() => {
      firstSeasonAverages.createRequest<getSeasonAveragesParamType>({
        'player_ids[]': props.playerId!,
        season: selectedFirstSeason.value
      })
    })

    const secondSeasonAverages = new UseRequest(getSeasonAverages)
    watchEffect(() => {
      secondSeasonAverages.createRequest<getSeasonAveragesParamType>({
        'player_ids[]': props.playerId!,
        season: selectedSecondSeason.value
      })
    })

    const getSeason = (season: number): string => {
      return `${String(season).substring(2, 4)} - ${String(season + 1).substring(2, 4)}`
    }

    const multiply100 = (pct: number): string => {
      return `${(pct * 100).toFixed(1)}%`
    }

    return {
      selectedFirstSeason,
      firstSeasonAverages,
      selectedSecondSeason,
      secondSeasonAverages,
      seasonList,
      getSeason,
      multiply100
    }
  }
});
